// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1-1VH","signatureButtonsRight":"ModalSign_signatureButtonsRight__1nxYr"};